<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="mt-3">
        <p class="font-weight-bold mb-0">{{$t('medium_grant_ev.admissibility__reference')}}</p>
        <span>{{EvaluationForm.application.reference}}</span>
      </div>
      <div class="mt-3">
        <p class="font-weight-bold mb-3">{{$t('medium_grant_ev.general__info_grid_by')}}</p>
        <div v-if="EvaluationForm.evaluation && EvaluationForm.evaluation.user">
          <div>{{EvaluationForm.evaluation.user.name}}</div>
          <small>{{EvaluationForm.evaluation.updated_at}}</small>
        </div>
        <div v-else>-</div>
      </div>
      <div class="mt-3">
        <p class="font-weight-bold mb-0">{{$t('medium_grant_ev.admissibility__title_of_proposal')}}</p>
        <span>{{EvaluationForm.application.title}}</span>
      </div>
      <div class="mt-3">
        <p class="font-weight-bold mb-0">{{$t('medium_grant_ev.admissibility__region')}}</p>
        <span v-if="EvaluationForm.application.region_details">{{EvaluationForm.application.region_details.name}}</span>
        <span v-else>-</span>
      </div>
    </div>
  </div>
</template>
<script>
  import {EvaluationForm} from "@/services";

  export default {
    data() {
      return {
        EvaluationForm
      }
    }
  }
</script>
